// 個人設定
$(() => {
    if (document.getElementById('agent-regist-invitation') != null) {
        $('.js-invitation-clear').on('click', function(e) {
            $(this).parent().parent().find('.js-invitation-email').val('');
            $(this).parent().parent().find('.js-invitation-role').val(1);
        });
    }

    if (document.getElementById('workflow') != null) {
        $('.js-add').on('click', function(e) {
            var html = $('.js-users option:selected').html();
            var id = $('.js-users option:selected').val();
            if (id) {
                $('.js-users option:selected').remove();
                $('.js-workflow').append($('<option class="list-group-item wf-item">').html(html).val(id));
            }
        });
        $('.js-remove').on('click', function(e) {
            var html = $('.js-workflow option:selected').html();
            var id = $('.js-workflow option:selected').val();
            if (id) {
                $('.js-workflow option:selected').remove();
                $('.js-users').append($('<option class="list-group-item wf-item">').html(html).val(id));
            }
        });
        $('.js-submit').on('click', function(e) {
            var id = [];
            $('.js-workflow option').each(function() {
                id.push($(this).val());
            });
            $('input[name="workflow"]').val(id.join(','));
        });

        $('.js-workflow-change').on('click', function(e) {
            if ($('#notification_users_all_application').prop("checked") ||
                $('#invoice_workflow_all_application').prop("checked") ||
                $('#report_workflow_all_application').prop("checked")
            ) {
                $('#notification_users_modal').modal('show');
            } else {
                $(this).prop('disabled', true);
                $('#workflow').submit();
            }
        });

        $('.submit_notification_users').on('click', function(e) {
            $('#workflow').submit();
        });

    }
});
